import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { MA_TYPE, PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { fillMovingAverage } from "../math/movingAverages";

const LINES = [
  { key: "jaws", period: "jawsPeriod" },
  { key: "teeth", period: "teethPeriod" },
  { key: "lips", period: "lipsPeriod" },
];

/**
 * Alligator (research §1.4), as TV Williams Alligator: smoothed (SMMA)
 * averages of hl2, each moved right by its shift.
 */
export default {
  id: "alligator",
  name: "Alligator",
  isOscillator: false,
  inputs: [
    periodInput("jawsPeriod", "Jaws Period", 13, { max: 100 }),
    periodInput("jawsShift", "Jaws Shift", 8, { max: 100 }),
    periodInput("teethPeriod", "Teeth Period", 8, { max: 100 }),
    periodInput("teethShift", "Teeth Shift", 5, { max: 100 }),
    periodInput("lipsPeriod", "Lips Period", 5, { max: 100 }),
    periodInput("lipsShift", "Lips Shift", 3, { max: 100 }),
  ],
  plots: [
    linePlot("lips", "Lips", PALETTE.LIME, { shift: (inputs) => inputs.lipsShift }),
    linePlot("teeth", "Teeth", PALETTE.AQUA, { shift: (inputs) => inputs.teethShift }),
    linePlot("jaws", "Jaws", PALETTE.YELLOW, { shift: (inputs) => inputs.jawsShift }),
  ],
  levels: [],

  calculate: (bars, inputs, series, fromIndex) => {
    const read = priceReader(bars, PRICE_SOURCE.HL2);

    LINES.forEach(({ key, period }) => {
      fillMovingAverage({
        type: MA_TYPE.SMMA,
        read,
        target: series[key],
        period: inputs[period],
        fromIndex,
        toIndex: bars.length,
      });
    });
  },
};
